// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2vLdx","filesListContainer":"PosDisputesFiles_filesListContainer__2CZot","filesButton":"PosDisputesFiles_filesButton__2Z9va"};